export const PAYMENT_TYPE_GPB = 'gpb'
export const PAYMENT_TYPE_GPB_SBP = 'gpb_sbp'

export type PaymentPluginId = typeof PAYMENT_TYPE_GPB | typeof PAYMENT_TYPE_GPB_SBP

export const PAYMENT_PLUGIN_NAMES: Record<PaymentPluginId, string> = {
  [PAYMENT_TYPE_GPB]: 'Банковская карта',
  [PAYMENT_TYPE_GPB_SBP]: 'СБП',
}
